<template>
  <TariffeTable />
</template>

<script>
import TariffeTable from '../components/pratiche/TableTariffeEe.vue'

export default {
  pageName: 'fatture',
  components: {
    TariffeTable
  },
  data() {
    return {

    }
  },



  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
}
</script>
